import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "../app/store";
import { SettingCustomizeChatType } from "../components/dashboard/dashboard-setting-customize-chat.component";

export interface IInitialSettingState {
  widget: SettingCustomizeChatType;
  humanClone: SettingCustomizeChatType;
}

const initialState: IInitialSettingState = {
  widget: {
    BotName: "",
    ShowInitialMessageAsTooltip: false,
    RemovePoweredByLouise: false,
    ChatOpenByDefault: false,
    Theme: "",
    ThemeColor: "",
    FloatButtonPosition: "",
    FloatButtonType: {
      type: "icon",
      value: "1"
    },
    ImageUlr: undefined,
    IsVoiceActive: undefined,
    IsVoiceResponseActive: undefined,
    save_conversation: undefined,
    alwaysShowButtons: undefined
  },
  humanClone: {
    BotName: "",
    ShowInitialMessageAsTooltip: false,
    RemovePoweredByLouise: false,
    ChatOpenByDefault: false,
    Theme: "",
    ThemeColor: "",
    FloatButtonPosition: "",
    FloatButtonType: {
      type: "icon",
      value: "1"
    },
    ImageUlr: undefined,
    IsVoiceActive: undefined,
    IsVoiceResponseActive: undefined,
    save_conversation: undefined,
    alwaysShowButtons: undefined
  }
};

export const SettingSlice: any = createSlice({
  name: "setting",
  initialState,
  reducers: {
    updateWidgetSettingData: (state, action) => {
      if (action && action?.payload) {
        state.widget = action.payload;
      }
    },
    updateHumanCloneSettingData: (state, action) => {
      if (action && action?.payload) {
        state.humanClone = action.payload;
      }
    }
  },
  extraReducers: (builder) => {}
});

export default SettingSlice.reducer;

export const { updateWidgetSettingData, updateHumanCloneSettingData } =
  SettingSlice.actions;

export const {} = SettingSlice.actions;
export const selectWidgetSetting = (state: RootState) =>
  (state.settingState as IInitialSettingState)?.widget;
export const selectHumanCloneSetting = (state: RootState) =>
  (state.settingState as IInitialSettingState)?.humanClone;
